import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { DEFAULT_FILTERS_PAGE_URL, DEFAULT_USER_FILTERS_PAGE_URL } from '../../constants/appUrls';
import { isSSR } from '../../utils/helpers';

enableStaticRendering(isSSR());

export class UtilStore {
    isUploadingAttachment: boolean;
    lastVisitedFilterPageUrl: string;
    lastVisitedUserFilterPageUrl: string;
    constructor() {
        this.isUploadingAttachment = false;
        this.lastVisitedFilterPageUrl = DEFAULT_FILTERS_PAGE_URL;
        this.lastVisitedUserFilterPageUrl = DEFAULT_USER_FILTERS_PAGE_URL;

        // Call it here
        makeAutoObservable(this);
    }

    setIsUploadingAttachment = (state: boolean): void => {
        this.isUploadingAttachment = state;
    };

    setLastVisitedFilterPageUrl: (url: string) => void = (url: string) => {
        this.lastVisitedFilterPageUrl = url;
    };
    setLastVisitedUserFilterPageUrl: (url: string) => void = (url: string) => {
        this.lastVisitedUserFilterPageUrl = url;
    };
}
